import { useCallback, useRef, useState } from 'react';
import BZAPIService from '../../../services/BZAPIService';

/**
 * Fetches the config-removed overlay for one version.
 *
 * The overlay is an enhancement, never a gate: if it fails, the caller still
 * renders the review list from human states alone. A generation token keeps a
 * slow response for a previous version from landing on the current one, which
 * would show marks computed for different data.
 */
export default function useConfigRemovedOverlay() {
  const [overlay, setOverlay] = useState(null);
  const [overlayError, setOverlayError] = useState(null);
  const runIdRef = useRef(0);

  const clearOverlay = useCallback(() => {
    runIdRef.current += 1;
    setOverlay(null);
    setOverlayError(null);
  }, []);

  const loadOverlay = useCallback(async (projectId, versionId) => {
    const runId = ++runIdRef.current;
    try {
      const data = await BZAPIService.bsaInvGetConfigRemoved(projectId, versionId);
      if (runIdRef.current !== runId) return;
      setOverlay(data || null);
      setOverlayError(null);
    } catch (e) {
      if (runIdRef.current !== runId) return;
      setOverlay(null);
      setOverlayError('Automatic marking is unavailable for this version.');
    }
  }, []);

  return { overlay, overlayError, loadOverlay, clearOverlay };
}
